import React from 'react';

function UnreadMessageIcon() {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='28' height='28' rx='4' fill='#FF4F2E' />
      <path
        d='M11.4233 10.12V8.709H14.6193V21H13.0553V10.12H11.4233Z'
        fill='white'
      />
    </svg>
  );
}

export default UnreadMessageIcon;
